import React from "react";

import { Hotspot } from "../../../Types";
import { Link } from "../../Icons/left-side-bar-icons";

function linkCheck(url: string | undefined): string | undefined {
  if (url) {
    if (url.startsWith("http") || url.startsWith("https")) {
      return url;
    } else {
      return "https://" + url;
    }
  }

  return;
}

function LinkHotspot({ spot }: { spot: Hotspot }) {
  return (
    <div className="hotspot link">
      <Link
        color={spot.isNew ? "#ff8700" : "white"}
        width="4rem"
        height="4rem"
        stroke="#282828"
        strokeWidth={"25px"}
      />

      {spot.isNew ? (
        !spot.EDIT_POS && <p>Non salvato</p>
      ) : spot.target ? (
        <a
          href={linkCheck(spot.target as string)}
          target="_blank"
          rel="noreferrer"
        >
          {spot.title || "Apri link"}
        </a>
      ) : (
        <span>Link mancante</span>
      )}
    </div>
  );
}

export default LinkHotspot;
